import { Injectable } from '@angular/core';
import {BsModalService} from "ngx-bootstrap/modal";
import {ModalAlertaComponent} from "../modals/modal-alerta/modal-alerta.component";
import {HttpErrorResponse} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private modalService: BsModalService) { }

  presentAlertaError(msg: string = '', error: HttpErrorResponse) {
    this.modalService.show(ModalAlertaComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs',
      initialState: {
        msg: msg,
        requestId: error['requestId'],
        tipo: 'ERROR'
      }
    });
  }

  presentAlertaWarning(msg: string = '') {
    this.modalService.show(ModalAlertaComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs',
      initialState: {
        msg: msg,
        tipo: 'WARNING'
      }
    });
  }

  presentAlertaInfo(msg: string = '') {
    this.modalService.show(ModalAlertaComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs',
      initialState: {
        msg: msg,
        tipo: 'INFO'
      }
    });
  }

}
